// src/pages/ListaComunicados.js - CÓDIGO FINAL Y CORREGIDO

import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { db } from '../firebase';
import { collection, query, where, getDocs, getDoc, orderBy, deleteDoc, doc, updateDoc } from 'firebase/firestore';
import { useAuth } from '../context/AuthContext';
import { FaBullhorn, FaEdit, FaTrash } from 'react-icons/fa';
import '../styles/comunidad.css';
import './ListaComunicados.css';

const ListaComunicados = () => {
    const { categoria } = useParams(); 
    const navigate = useNavigate();
    
    // Obtenemos el objeto userData COMPLETO. Ya no necesitamos el estado de carga del contexto aquí.
    const { userData } = useAuth();

    const [comunicados, setComunicados] = useState([]);
    const [loading, setLoading] = useState(true); // Este es el estado de carga de ESTE componente
    const [error, setError] = useState(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [selectedComunicado, setSelectedComunicado] = useState(null);

    useEffect(() => {
        // --- LA GUARDIA MÁS IMPORTANTE ---
        // Si userData aún no se ha cargado (es null o undefined),
        // simplemente no hacemos NADA en este ciclo de renderizado.
        // El useEffect se volverá a ejecutar cuando userData cambie.
        if (!userData) {
            return;
        }

        const fetchComunicados = async () => {
            // Ahora que estamos aquí, estamos 100% seguros de que userData existe.
            const fraccionamientoId = userData.fraccionamientoId || userData.fraccionamientoTd || null;

                console.log('[ListaComunicados] userData:', userData);
                console.log('[ListaComunicados] fraccionamientoId:', fraccionamientoId);
                console.log('[ListaComunicados] categoria:', categoria);

            // Si por alguna razón el usuario no tiene fraccionamientoId, lo manejamos.
            if (!fraccionamientoId) {
                setError("El usuario no tiene un fraccionamiento asignado.");
                setLoading(false);
                return;
            }

            try {
                const comunicadosRef = collection(db, 'fraccionamientos', fraccionamientoId, 'comunicados');
                    console.log('[ListaComunicados] Consultando comunicados en:', `fraccionamientos/${fraccionamientoId}/comunicados`);
                
                const q = query(
                    comunicadosRef, 
                    where("categoria", "==", categoria),
                    orderBy("fecha", "desc")
                );

                const querySnapshot = await getDocs(q);
                    console.log('[ListaComunicados] Comunicados obtenidos:', querySnapshot.size);
                
                const listaComunicados = querySnapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data(),
                    fechaFormateada: new Date(doc.data().fecha.seconds * 1000).toLocaleString('es-MX', { dateStyle: 'long', timeStyle: 'short' })
                }));

                setComunicados(listaComunicados);
            } catch (err) {
                console.error("Error al obtener comunicados: ", err);
                    console.error("Error completo: ", JSON.stringify(err, null, 2));
                    console.error("Error code: ", err.code);
                    console.error("Error message: ", err.message);
                setError("No se pudieron cargar los comunicados. Verifica tus permisos.");
            } finally {
                setLoading(false);
            }
        };

        fetchComunicados();
        
    // La dependencia ahora es el objeto userData. Cuando cambie de null al objeto real, este hook se ejecutará de nuevo.
    }, [categoria, userData]);

    const handleDeleteClick = (comunicado) => {
        setSelectedComunicado(comunicado);
        setShowDeleteModal(true);
    };

    const handleDeleteConfirm = async () => {
        if (!selectedComunicado || !userData) return;

        const fraccionamientoId = userData.fraccionamientoId || userData.fraccionamientoTd;
        try {
            await deleteDoc(doc(db, 'fraccionamientos', fraccionamientoId, 'comunicados', selectedComunicado.id));
            setComunicados(prev => prev.filter(c => c.id !== selectedComunicado.id));
            setShowDeleteModal(false);
            setSelectedComunicado(null);
        } catch (error) {
            console.error('Error al eliminar comunicado:', error);
            alert('Error al eliminar el comunicado');
        }
    };

    const handleEditClick = (comunicado) => {
        navigate(`/comunidad/comunicados/editar/${comunicado.id}`, { 
            state: { 
                editMode: true, 
                comunicadoId: comunicado.id,
                comunicadoData: comunicado 
            } 
        });
    };

    const role = String(userData?.rol || '').toLowerCase();
    const isAdmin = ['superadmin', 'admin', 'manager', 'plataforma', 'admin_fracc'].includes(role);

    const [tabSeccion, setTabSeccion] = useState('recientes'); // 'recientes' | 'historial'
    const [paginaRecientes, setPaginaRecientes] = useState(1);
    const [paginaHistorial, setPaginaHistorial] = useState(1);
    const ITEMS_PER_PAGE = 5;

    const ahora = new Date();
    const esReciente = (c) => {
        if (c.eventoRelacionadoFecha) {
            const fechaEv = c.eventoRelacionadoFecha.toDate ? c.eventoRelacionadoFecha.toDate() : new Date(c.eventoRelacionadoFecha);
            return fechaEv >= ahora;
        }
        if (c.fecha) {
            const fechaPub = c.fecha.toDate ? c.fecha.toDate() : (c.fecha.seconds ? new Date(c.fecha.seconds * 1000) : new Date(c.fecha));
            return fechaPub.getMonth() === ahora.getMonth() && fechaPub.getFullYear() === ahora.getFullYear();
        }
        return true;
    };

    const comunicadosRecientes = comunicados.filter(esReciente);
    const comunicadosHistorial = comunicados.filter((c) => !esReciente(c));

    const totalPaginasRecientes = Math.ceil(comunicadosRecientes.length / ITEMS_PER_PAGE) || 1;
    const recientesPaginados = comunicadosRecientes.slice((paginaRecientes - 1) * ITEMS_PER_PAGE, paginaRecientes * ITEMS_PER_PAGE);

    const totalPaginasHistorial = Math.ceil(comunicadosHistorial.length / ITEMS_PER_PAGE) || 1;
    const historialPaginados = comunicadosHistorial.slice((paginaHistorial - 1) * ITEMS_PER_PAGE, paginaHistorial * ITEMS_PER_PAGE);

    const listaActual = tabSeccion === 'recientes' ? recientesPaginados : historialPaginados;
    const paginaActual = tabSeccion === 'recientes' ? paginaRecientes : paginaHistorial;
    const totalPaginasActual = tabSeccion === 'recientes' ? totalPaginasRecientes : totalPaginasHistorial;
    const setPaginaActual = tabSeccion === 'recientes' ? setPaginaRecientes : setPaginaHistorial;

    const [lecturasData, setLecturasData] = useState({});
    const [expandedLecturas, setExpandedLecturas] = useState({});
    const userProfileCacheRef = useRef({});
    const casasCacheRef = useRef({});

    useEffect(() => {
        if (!isAdmin || !userData || listaActual.length === 0) return;

        const fraccionamientoId = userData.fraccionamientoId || userData.fraccionamientoTd;
        if (!fraccionamientoId) return;

        let isMounted = true;
        const fetchLecturas = async () => {
            try {
                const nuevasLecturas = {};
                await Promise.all(
                    listaActual.map(async (comunicado) => {
                        try {
                            const lecturasRef = collection(db, 'fraccionamientos', fraccionamientoId, 'comunicados', comunicado.id, 'lecturas');
                            const snap = await getDocs(lecturasRef);

                            const docs = await Promise.all(
                                snap.docs.map(async (d) => {
                                    const data = d.data() || {};
                                    let fechaStr = '';
                                    if (data.leidoEn) {
                                        if (typeof data.leidoEn.toDate === 'function') {
                                            fechaStr = data.leidoEn.toDate().toLocaleString('es-MX', { dateStyle: 'short', timeStyle: 'short' });
                                        } else if (data.leidoEn.seconds) {
                                            fechaStr = new Date(data.leidoEn.seconds * 1000).toLocaleString('es-MX', { dateStyle: 'short', timeStyle: 'short' });
                                        } else {
                                            fechaStr = new Date(data.leidoEn).toLocaleString('es-MX', { dateStyle: 'short', timeStyle: 'short' });
                                        }
                                    }

                                    let casaResuelta = String(data.casa || data.numeroCasa || '').trim();
                                    let nombreResuelto = String(data.nombre || data.nombreCompleto || '').trim();
                                    const userId = d.id || data.usuarioId;

                                    // Si no tenemos casa o nombre (o si era "Sin número" / "S/N"), consultamos el perfil del usuario
                                    if ((!casaResuelta || casaResuelta === 'Sin número' || casaResuelta === 'S/N' || !nombreResuelto) && userId) {
                                        let perfil = userProfileCacheRef.current[userId];
                                        if (!perfil) {
                                            try {
                                                const userSnap = await getDoc(doc(db, 'usuarios', userId));
                                                if (userSnap.exists()) {
                                                    perfil = userSnap.data();
                                                    userProfileCacheRef.current[userId] = perfil;
                                                }
                                            } catch (e) {
                                                console.warn(`Error obteniendo perfil de usuario ${userId}:`, e);
                                            }
                                        }

                                        if (perfil) {
                                            if (!nombreResuelto) {
                                                nombreResuelto = (
                                                    perfil.nombreCompleto ||
                                                    perfil.nombre ||
                                                    `${perfil.nombres || ''} ${perfil.apellidos || ''}`.trim() ||
                                                    perfil.displayName ||
                                                    perfil.email ||
                                                    ''
                                                ).trim();
                                            }

                                            if (!casaResuelta || casaResuelta === 'Sin número' || casaResuelta === 'S/N') {
                                                casaResuelta = String(
                                                    perfil.numeroCasa ||
                                                    perfil.casa ||
                                                    perfil.casaNumero ||
                                                    perfil.lote ||
                                                    perfil.numero ||
                                                    perfil.houseLabel ||
                                                    ''
                                                ).trim();

                                                // Si el perfil no tiene número directo pero tiene casaId, buscar en casas
                                                if (!casaResuelta && perfil.casaId) {
                                                    let casaData = casasCacheRef.current[perfil.casaId];
                                                    if (!casaData) {
                                                        try {
                                                            const casaSnap = await getDoc(doc(db, 'fraccionamientos', fraccionamientoId, 'casas', perfil.casaId));
                                                            if (casaSnap.exists()) {
                                                                casaData = casaSnap.data();
                                                                casasCacheRef.current[perfil.casaId] = casaData;
                                                            }
                                                        } catch (e) {
                                                            console.warn(`Error obteniendo casa ${perfil.casaId}:`, e);
                                                        }
                                                    }
                                                    if (casaData) {
                                                        casaResuelta = String(casaData.numero || casaData.numeroCasa || casaData.lote || '').trim();
                                                    }
                                                }
                                            }
                                        }
                                    }

                                    return {
                                        id: d.id,
                                        ...data,
                                        casa: (casaResuelta && casaResuelta !== 'Sin número') ? casaResuelta : 'S/N',
                                        nombre: nombreResuelto,
                                        fechaFormateada: fechaStr
                                    };
                                })
                            );

                            nuevasLecturas[comunicado.id] = {
                                count: snap.size,
                                lecturas: docs
                            };
                        } catch (e) {
                            console.error(`Error al cargar lecturas de comunicado ${comunicado.id}:`, e);
                            nuevasLecturas[comunicado.id] = { count: 0, lecturas: [] };
                        }
                    })
                );
                if (isMounted) {
                    setLecturasData(prev => ({ ...prev, ...nuevasLecturas }));
                }
            } catch (err) {
                console.error('Error general al cargar lecturas:', err);
            }
        };

        fetchLecturas();

        return () => { isMounted = false; };
    }, [listaActual, isAdmin, userData]);

    const toggleExpandLecturas = (comunicadoId) => {
        setExpandedLecturas(prev => ({
            ...prev,
            [comunicadoId]: !prev[comunicadoId]
        }));
    };

    if (loading) return <div className="loading-message">Cargando comunicados...</div>;
    if (error) return <div className="error-message">{error}</div>;

    return (
        <div className="votaciones-page">
            <div className="modal-card">
                <div className="modal-header" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '12px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
                        <button 
                            className="btn-outline header-back-btn" 
                            onClick={() => navigate('/comunidad/avisos')} 
                            style={{ color: '#fff', borderColor: 'rgba(255,255,255,0.4)', background: 'transparent', padding: '6px 14px', borderRadius: '10px' }}
                        >
                            ← Volver
                        </button>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <FaBullhorn style={{ fontSize: '1.4em', opacity: 0.95 }} />
                            <h2 style={{ margin: 0 }}>{categoria}</h2>
                        </div>
                    </div>
                    {isAdmin && (
                        <button 
                            className="btn-gradient header-create-btn" 
                            onClick={() => navigate('/comunidad/comunicados/nuevo')}
                            style={{ padding: '8px 16px', borderRadius: '12px' }}
                        >
                            + Nuevo Comunicado
                        </button>
                    )}
                </div>
                
                <div className="votaciones-content" style={{ padding: '24px 28px' }}>
                    {/* Selector Zen de Secciones: Recientes / Historial */}
                    <div className="votaciones-categorias-bar" style={{ marginBottom: '24px' }}>
                        <button
                            type="button"
                            className={`votaciones-cat-pill ${tabSeccion === 'recientes' ? 'active' : ''}`}
                            onClick={() => { setTabSeccion('recientes'); setPaginaRecientes(1); }}
                        >
                            📅 Recientes <span className="cat-count">({comunicadosRecientes.length})</span>
                        </button>
                        <button
                            type="button"
                            className={`votaciones-cat-pill ${tabSeccion === 'historial' ? 'active' : ''}`}
                            onClick={() => { setTabSeccion('historial'); setPaginaHistorial(1); }}
                        >
                            📜 Historial (Pasados) <span className="cat-count">({comunicadosHistorial.length})</span>
                        </button>
                    </div>

                    <div className="comunicados-list">
                        {listaActual.length === 0 ? (
                            <p className="no-comunicados">
                                {tabSeccion === 'recientes'
                                    ? 'No hay comunicados vigentes o próximos en esta categoría.'
                                    : 'No hay comunicados pasados en el historial.'}
                            </p>
                        ) : (
                            listaActual.map(comunicado => (
                                <div key={comunicado.id} className="comunicado-card">
                                    <div className="comunicado-content">
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                                            <h2 style={{ margin: 0 }}>{comunicado.titulo}</h2>
                                            {(comunicado.tipoDestinatarios === 'morosos' || comunicado.enviarSoloMorosos || comunicado.soloMorosos) && (
                                                <span style={{
                                                    fontSize: '0.72rem',
                                                    fontWeight: '600',
                                                    backgroundColor: '#fff3cd',
                                                    color: '#856404',
                                                    padding: '2px 8px',
                                                    borderRadius: '12px',
                                                }}>
                                                    🔒 Solo morosos
                                                </span>
                                            )}
                                            {(comunicado.tipoDestinatarios === 'personalizado' || (Array.isArray(comunicado.casasHabilitadas) && comunicado.casasHabilitadas.length > 0)) && (
                                                <span style={{
                                                    fontSize: '0.72rem',
                                                    fontWeight: '600',
                                                    backgroundColor: '#e0e7ff',
                                                    color: '#3730a3',
                                                    padding: '2px 8px',
                                                    borderRadius: '12px',
                                                }}>
                                                    🏠 Domicilios ({comunicado.casasHabilitadas?.length || 0})
                                                </span>
                                            )}
                                        </div>
                                        <p>{comunicado.descripcion}</p>
                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '10px', marginTop: '10px' }}>
                                            <small>Publicado: {comunicado.fechaFormateada}</small>
                                            {isAdmin && (
                                                <button
                                                    type="button"
                                                    className={`comunicado-lecturas-pill ${expandedLecturas[comunicado.id] ? 'active' : ''}`}
                                                    onClick={() => toggleExpandLecturas(comunicado.id)}
                                                    title="Ver residentes que han marcado este comunicado como leído"
                                                >
                                                    <span className="lecturas-icon">👁️</span>
                                                    <span className="lecturas-texto">
                                                        {lecturasData[comunicado.id] !== undefined
                                                            ? `${lecturasData[comunicado.id].count} ${lecturasData[comunicado.id].count === 1 ? 'leído' : 'leídos'}`
                                                            : 'Cargando...'}
                                                    </span>
                                                    <span className="lecturas-arrow">
                                                        {expandedLecturas[comunicado.id] ? '▲' : '▼'}
                                                    </span>
                                                </button>
                                            )}
                                        </div>

                                        {isAdmin && expandedLecturas[comunicado.id] && (
                                            <div className="comunicado-lecturas-dropdown">
                                                {lecturasData[comunicado.id]?.count > 0 ? (
                                                    <div>
                                                        <div className="lecturas-dropdown-header">
                                                            <strong>Residentes que confirmaron lectura ({lecturasData[comunicado.id].count}):</strong>
                                                        </div>
                                                        <div className="lecturas-chips-grid">
                                                            {lecturasData[comunicado.id].lecturas.map((item) => (
                                                                <div key={item.id} className="lectura-chip">
                                                                    <span className="chip-casa">🏠 Casa {item.casa || 'S/N'}</span>
                                                                    {item.nombre && <span className="chip-nombre">· {item.nombre}</span>}
                                                                    {item.fechaFormateada && <span className="chip-fecha">({item.fechaFormateada})</span>}
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div className="lecturas-dropdown-empty">
                                                        <span>ℹ️ Ningún residente ha marcado este aviso como leído todavía.</span>
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                    {isAdmin && (
                                        <div className="comunicado-actions">
                                            <button 
                                                className="btn-edit" 
                                                onClick={() => handleEditClick(comunicado)}
                                                title="Editar"
                                            >
                                                <FaEdit />
                                            </button>
                                            <button 
                                                className="btn-delete" 
                                                onClick={() => handleDeleteClick(comunicado)}
                                                title="Eliminar"
                                            >
                                                <FaTrash />
                                            </button>
                                        </div>
                                    )}
                                </div>
                            ))
                        )}
                    </div>

                    {totalPaginasActual > 1 && (
                        <div className="votaciones-paginacion" style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '12px',
                            marginTop: '24px'
                        }}>
                            <button
                                type="button"
                                className="btn-zen-action"
                                onClick={() => setPaginaActual(p => Math.max(1, p - 1))}
                                disabled={paginaActual === 1}
                                style={{ opacity: paginaActual === 1 ? 0.4 : 1, cursor: paginaActual === 1 ? 'not-allowed' : 'pointer' }}
                            >
                                ← Anterior
                            </button>
                            <span style={{ fontSize: '0.88rem', fontWeight: '600', color: '#64748b' }}>
                                Página {paginaActual} de {totalPaginasActual}
                            </span>
                            <button
                                type="button"
                                className="btn-zen-action"
                                onClick={() => setPaginaActual(p => Math.min(totalPaginasActual, p + 1))}
                                disabled={paginaActual === totalPaginasActual}
                                style={{ opacity: paginaActual === totalPaginasActual ? 0.4 : 1, cursor: paginaActual === totalPaginasActual ? 'not-allowed' : 'pointer' }}
                            >
                                Siguiente →
                            </button>
                        </div>
                    )}
                </div>
            </div>

            {/* Modal de confirmación para eliminar */}
            {showDeleteModal && (
                <div className="modal-overlay" onClick={() => setShowDeleteModal(false)}>
                    <div className="modal-dialog" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-dialog-header">
                            <h3>Confirmar eliminación</h3>
                        </div>
                        <div className="modal-dialog-body">
                            <p>¿Estás seguro de que deseas eliminar este comunicado?</p>
                            <p style={{fontWeight: 'bold', marginTop: '12px'}}>{selectedComunicado?.titulo}</p>
                        </div>
                        <div className="modal-dialog-footer">
                            <button 
                                className="comunidad-btn-secondary" 
                                onClick={() => setShowDeleteModal(false)}
                            >
                                Cancelar
                            </button>
                            <button 
                                className="btn-delete-confirm" 
                                onClick={handleDeleteConfirm}
                            >
                                Eliminar
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ListaComunicados;